import React, { useEffect } from 'react';
import histogram from '../../assets/images/icon_histogram.png';
import boxplot from '../../assets/images/icon_boxplot.png';
import bar from '../../assets/images/Icon_time-series.png';
import line from '../../assets/images/line.png'; // Assuming you have a line chart icon

const SegmentedControl_totalMileage = ({ selected, onChange = () => {}, vinShort = [] }) => {
  const isSingleVehicle = Array.isArray(vinShort) && vinShort.length === 1;

  // Auto-select 'histogram' if more than one vehicle is selected and current is 'Bar'
  useEffect(() => {
    if (!isSingleVehicle && selected === 'Bar') {
      onChange('histogram');
    }
  }, [vinShort, selected]);

  const segments = [
    ...(isSingleVehicle ? [{ label: 'Time Series', value: 'Bar', icon: line }] : []),
    { label: 'Histogram', value: 'histogram', icon: histogram },
    { label: 'Boxplot', value: 'boxplot', icon: boxplot },
  ];

  const containerStyle = {
    display: 'flex',
    border: '1px solid gray',
    borderRadius: '16px', // Reduced for a more compact look
    overflow: 'hidden',
    marginLeft: '10px',
  };

  const buttonStyle = (isSelected) => ({
    padding: '4px 12px', // Restored original padding
    cursor: 'pointer',
    backgroundColor: isSelected ? '#CBD3DC' : '#ffffff', // Changed to #CBD3DC for selected state
    color: isSelected ? '#000000' : '#000000', // Black text for contrast
    border: 'none',
    outline: 'none',
    fontWeight: isSelected ? 'bold' : 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  const iconStyle = {
    height: '16px', // Reduced icon height
    width: '16px', // Adjusted width to maintain aspect ratio
  };

  return (
    <div style={containerStyle}>
      {segments.map((segment) => (
        <button
          key={segment.value || segment.label}
          style={buttonStyle(selected === (segment.value || segment.label))}
          onClick={() => onChange(segment.value || segment.label)}
          title={segment.label}
        >
          <img src={segment.icon} alt={segment.label} style={iconStyle} />
        </button>
      ))}
    </div>
  );
};

export default SegmentedControl_totalMileage;